<template>
  <svg
    fill="none"
    height="1em"
    viewBox="0 0 17 16"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.65972 1.3335H5.82267C5.70302 1.3335 5.64319 1.3335 5.59037 1.35171C5.54366 1.36783 5.50112 1.39412 5.46582 1.42869C5.42591 1.46778 5.39915 1.5213 5.34564 1.62832L2.54564 7.22831C2.41786 7.48389 2.35396 7.61168 2.36931 7.71555C2.38271 7.80625 2.43288 7.88743 2.50802 7.93998C2.59406 8.00016 2.73693 8.00016 3.02267 8.00016H7.15972L5.15972 14.6668L13.2884 6.23703C13.5627 5.95263 13.6998 5.81043 13.7078 5.68875C13.7148 5.58313 13.6712 5.48049 13.5903 5.41218C13.4972 5.3335 13.2996 5.3335 12.9045 5.3335H8.15972L9.65972 1.3335Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.4"
    />
  </svg>
</template>
